import { render, staticRenderFns } from "./PointStock.vue?vue&type=template&id=59317180&"
import script from "./PointStock.vue?vue&type=script&lang=js&"
export * from "./PointStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports